import React, { Component } from "react";
import axios from 'axios';
import ReactDOM from 'react-dom'
import "../App.css";
import Results from "./results";

class search extends Component {

    constructor(props){
        super(props)
        this.state = {
            search: ''
        }
        this.goSearch = this.goSearch.bind(this);
    }
    

    hideButton(){
        document.getElementById('searchBtn').style.opacity = "0";
        document.getElementById('searchBtn').style.pointerEvents = 'none';
    }
    showButton = () => {
        document.getElementById('searchBtn').style.opacity = "1";
        document.getElementById('searchBtn').style.pointerEvents = 'all';
    }
    
    handleInputChange = (event) => {
        (event.target.value === '') ? this.hideButton() : this.showButton()
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handleSearch = () => {
        document.querySelector('.searchInput').blur();
        this.showLoadingScreen();
        this.goSearch();
    }
    
    handleEnter = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            document.getElementById("searchBtn").click();
        }
    }

    goSearch(){
        console.log('fetching shows...')
        const BASE_URL ="https://stormy-savannah-16187.herokuapp.com/api/v1/shows"
        const params = new URLSearchParams({
            term: this.state.search.toLowerCase(),
            country: 'uk'
        });
        axios.get(`${BASE_URL}?${params}`)
        .then((response) => {
            let results = response.data.results;
            let foundShows = [];
            results.forEach(result => {
                let idToUse
                let nameNoSpace = result.name.toLowerCase().replace(/[^A-Z0-9]+/ig, "-");
                result.external_ids.imdb === null ? idToUse = nameNoSpace : idToUse = result.external_ids.imdb.id
                let show = {
                    name: result.name,
                    pic: result.picture,
                    locations: [],
                    id: idToUse
                };
                let resultLocations = result.locations;
                resultLocations.forEach(resultLocation => {
                    show.locations.push({ name: resultLocation.display_name, pic: resultLocation.icon, link: resultLocation.url })
                });
                foundShows.push(show);
            });
            this.renderResults(foundShows);
        })
        .catch((error) => {
            console.log(error);
        })
    }

    showLoadingScreen(){
        document.querySelector('.loading-screen').style.opacity=1;
        document.querySelector('.footer').style.opacity=0;
        document.querySelector('.loading-screen').style.pointerEvents="all";
    }

    renderResults(foundShows){
        document.querySelector('.loading-screen').style.opacity = 0
        document.querySelector('.loading-screen').style.pointerEvents = "none"
        document.querySelector('.results-container').style.display="flex"
        ReactDOM.unmountComponentAtNode(document.querySelector('.results-container'))
        ReactDOM.render(<Results foundShows={foundShows}/>, document.querySelector('.results-container'));
        window.scrollTo({
            top: window.innerHeight*0.7,
            left: 0,
            behavior: 'smooth'
        });
        document.querySelector('.footer').style.opacity = 1;
    }

    render() {
        return (
            <div className="search-container">
                <div className="searchbar">
                    <div className="bar-container">
                        <span role="img" aria-label="search">🔎&nbsp;</span>
                        <input
                            autoFocus="autofocus"
                            autoComplete="off"
                            className="searchInput"
                            name="search"
                            type="text"
                            placeholder="what d'ya wanna watch?"
                            onChange={this.handleInputChange}
                            onKeyUp={this.handleEnter}
                        />
                    </div>
                    <button id="searchBtn" onClick={this.handleSearch}>search &nbsp;<span role="img" aria-label="search">🔎</span></button>
                </div>
                <div className="results-container">
                </div>
            </div>
        )
    }
}
export default search;
